import PropTypes from "prop-types"
import { MenuLink } from "@reach/menu-button"

const FilterButton = ({ disabled = false, onSubmit }) => {
  return (
    <div className="pt-2">
      <MenuLink
        onSelect={() => onSubmit()}
        className="btn2 quiet-app-btn"
        style={{ color: disabled ? "#D3D3D3" : "#58b6ae", padding: "0 1rem" }}
        disabled={disabled}
      >
        Add filter
      </MenuLink>
    </div>
  )
}

FilterButton.propTypes = {
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func
}

export default FilterButton
